import { memo, useMemo } from 'react';

import { PublicShowcaseAssetModalDesktopLayout } from '~/components/AssetModalV2/PublicShowcaseAssetModalDesktopLayout';
import { PublicAssetModalShell } from '~/components/PublicAssetModal/PublicAssetModalShell';
import { usePublicAssetModalNavigation } from '~/providers/PublicAssetModalNavigationProvider';

export const PublicShowcaseAssetModal = memo(() => {
  // The surface's asset-modal navigation contract owns the close; it rides props from here down to the
  // close consumers (the header's close button, the layout's esc-key handler).
  const { onCloseAssetModal } = usePublicAssetModalNavigation();

  const desktop = useMemo(
    () => <PublicShowcaseAssetModalDesktopLayout onCloseAssetModal={onCloseAssetModal} />,
    [onCloseAssetModal],
  );

  return <PublicAssetModalShell desktop={desktop} />;
});

PublicShowcaseAssetModal.displayName = 'PublicShowcaseAssetModal';
